<script setup lang="ts">
import { useRouter } from 'vue-router';
import { DgrIcon, DgrPopover } from '@stockmarkteam/donguri-ui';
import signout from '@/utils/signout';
import { useGTag } from '@/utils/vue';
import { featureFlags } from '@/featureFlags';

const router = useRouter();
const gtag = useGTag();

const dropdownZIndex = Number(
  // ヘッダーよりも上に表示する
  getComputedStyle(document.body).getPropertyValue('--z-header') + 1,
);

const handleLogout = async (close: () => void) => {
  close();
  await signout(gtag, router);
};
</script>

<template>
  <DgrPopover
    v-if="featureFlags.ANDEV_10131_CAPABILITY"
    :z-index="dropdownZIndex"
  >
    <template #default="{ triggerProps }">
      <button
        v-bind="triggerProps"
        v-tooltip="{ content: 'アカウント', triggers: ['hover'] }"
        type="button"
        class="user-menu"
      >
        <DgrIcon name="user-circle" class="icon" />
      </button>
    </template>
    <template #content="{ close }">
      <div class="user-dropdown c-text c-text--m">
        <router-link
          :to="{ name: 'userSettingsProfile' }"
          class="dropdown-item"
          target="_blank"
          @click="close"
        >
          プロフィール
          <DgrIcon
            name="external-link"
            size="small"
            :keep-fill="false"
            class="item-icon"
          />
        </router-link>
        <hr class="dropdown-divider" />
        <button
          type="button"
          class="dropdown-item logout-item"
          @click="handleLogout(close)"
        >
          ログアウト
          <DgrIcon
            name="sign-out"
            size="small"
            :keep-fill="false"
            class="item-icon"
          />
        </button>
      </div>
    </template>
  </DgrPopover>
</template>

<style scoped lang="scss">
.user-menu {
  &:hover {
    background: $color-gray200;
  }

  border: none;
  background: none;
  width: 32px;
  height: 32px;
  padding: 4px;
}

.user-dropdown {
  box-shadow: 0px 1px 5px rgba($color-gray1000, 0.25);
  border-radius: 4px;
  padding: 4px;

  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 140px;
  box-sizing: border-box;

  .dropdown-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 4px 8px;
    border-radius: 2px;
    text-align: left;
    width: 100%;
    box-sizing: border-box;

    &:hover {
      background: $color-gray200;
    }
  }

  .logout-item {
    border: none;
    background: none;
    // 共通の button の高さ（40px）を打ち消し、プロフィールの行と揃える
    height: auto;
    font: inherit;
  }

  .item-icon {
    margin-left: auto;
    flex-shrink: 0;
  }

  .dropdown-divider {
    margin: 0;
    border-top: 1px solid $color-gray400;
    border-bottom: 0;
  }
}

.icon {
  width: 24px;
  height: 24px;
}
</style>
